import { buildApiUrl } from "utils/index";
import queryString from "query-string";
import { useCallback, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const useParams = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const pathname = location.pathname;
  const parsed = useMemo(
    () => queryString.parse(location.search),
    [location.search]
  );

  const setParams = useCallback(
    (newParams) =>
      navigate(`${pathname}${buildApiUrl({ ...parsed, ...newParams })}`),
    [navigate, parsed, pathname]
  );
  const clearParams = (clearedParams) => {
    clearedParams.forEach((key) => {
      delete parsed[key];
    });

    navigate(`${pathname}${buildApiUrl(parsed)}`);
  };
  const clearAllParams = () => navigate(pathname);

  return { pathname, parsed, setParams, clearParams, clearAllParams };
};

export default useParams;
